module.exports = __webpack_public_path__ + "img/Solid.8ef3c1f9.png";